/** 뉴스룸 표시 날짜: yyyy.mm.dd */

function isValidDateParts(year: string, month: string, day: string): boolean {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  if (m < 1 || m > 12 || d < 1) return false;
  const lastDay = new Date(y, m, 0).getDate();
  return d <= lastDay;
}

function toDottedDate(year: string, month: string, day: string): string {
  return `${year}.${month.padStart(2, "0")}.${day.padStart(2, "0")}`;
}

/**
 * Admin 뉴스룸 날짜 정규화.
 * - yyyymmdd (예: 20250518) → yyyy.mm.dd
 * - yyyy.mm.dd / yyyy-mm-dd / yyyy/mm/dd → yyyy.mm.dd (zero-padding)
 */
export function normalizeNewsroomDate(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (/^\d{8}$/.test(trimmed)) {
    const y = trimmed.slice(0, 4);
    const m = trimmed.slice(4, 6);
    const d = trimmed.slice(6, 8);
    if (!isValidDateParts(y, m, d)) return null;
    return toDottedDate(y, m, d);
  }

  const separated = trimmed.match(/^(\d{4})[./-](\d{1,2})[./-](\d{1,2})$/);
  if (separated) {
    const [, y, m, d] = separated;
    if (!isValidDateParts(y, m, d)) return null;
    return toDottedDate(y, m, d);
  }

  return null;
}
